/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as GuestRouteImport } from './routes/_guest'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as RequestAccessRouteImport } from './routes/request-access'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as GuestLoginRouteImport } from './routes/_guest/login'
import { Route as AuthenticatedAgendaIndexRouteImport } from './routes/_authenticated/agenda/index'
import { Route as AuthenticatedAssetsIdRouteImport } from './routes/_authenticated/assets/$id'
import { Route as AuthenticatedAssistancesIndexRouteImport } from './routes/_authenticated/assistances/index'
import { Route as AuthenticatedAssistancesIdRouteImport } from './routes/_authenticated/assistances/$id'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedWorkOrdersIdRouteImport } from './routes/_authenticated/work-orders/$id'
import { Route as AuthenticatedAssetsIdIndexRouteImport } from './routes/_authenticated/assets/$id/index'
import { Route as AuthenticatedWorkOrdersIdIndexRouteImport } from './routes/_authenticated/work-orders/$id/index'
import { Route as AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteImport } from './routes/_authenticated/work-orders/$id/worksheets/$worksheetId'
import { Route as AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRouteImport } from './routes/_authenticated/work-orders/$id/worksheets/$worksheetId/index'
import { Route as AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRouteImport } from './routes/_authenticated/work-orders/$id/worksheets/$worksheetId/messages'
import { Route as AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRouteImport } from './routes/_authenticated/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId'
import { Route as AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRouteImport } from './routes/_authenticated/work-orders/$id/worksheets/$worksheetId/steps/$stepId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestRoute = GuestRouteImport.update({
  id: '/_guest',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestAccessRoute = RequestAccessRouteImport.update({
  id: '/request-access',
  path: '/request-access',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const GuestLoginRoute = GuestLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => GuestRoute,
} as any)
const AuthenticatedAgendaIndexRoute =
  AuthenticatedAgendaIndexRouteImport.update({
    id: '/agenda/',
    path: '/agenda/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetsIdRoute = AuthenticatedAssetsIdRouteImport.update({
  id: '/assets/$id',
  path: '/assets/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAssistancesIndexRoute =
  AuthenticatedAssistancesIndexRouteImport.update({
    id: '/assistances/',
    path: '/assistances/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssistancesIdRoute =
  AuthenticatedAssistancesIdRouteImport.update({
    id: '/assistances/$id',
    path: '/assistances/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkOrdersIdRoute =
  AuthenticatedWorkOrdersIdRouteImport.update({
    id: '/work-orders/$id',
    path: '/work-orders/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetsIdIndexRoute =
  AuthenticatedAssetsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAssetsIdRoute,
  } as any)
const AuthenticatedWorkOrdersIdIndexRoute =
  AuthenticatedWorkOrdersIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkOrdersIdRoute,
  } as any)
const AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute =
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteImport.update({
    id: '/worksheets/$worksheetId',
    path: '/worksheets/$worksheetId',
    getParentRoute: () => AuthenticatedWorkOrdersIdRoute,
  } as any)
const AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRoute =
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute,
  } as any)
const AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRoute =
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute,
  } as any)
const AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRoute =
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRouteImport.update(
    {
      id: '/protocols/$additionalProtocolId',
      path: '/protocols/$additionalProtocolId',
      getParentRoute: () => AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute,
    } as any,
  )
const AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRoute =
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRouteImport.update({
    id: '/steps/$stepId',
    path: '/steps/$stepId',
    getParentRoute: () => AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/logout': typeof LogoutRoute
  '/request-access': typeof RequestAccessRoute
  '/login': typeof GuestLoginRoute
  '/assets/$id': typeof AuthenticatedAssetsIdRouteWithChildren
  '/assistances/$id': typeof AuthenticatedAssistancesIdRoute
  '/work-orders/$id': typeof AuthenticatedWorkOrdersIdRouteWithChildren
  '/agenda/': typeof AuthenticatedAgendaIndexRoute
  '/assistances/': typeof AuthenticatedAssistancesIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/assets/$id/': typeof AuthenticatedAssetsIdIndexRoute
  '/work-orders/$id/': typeof AuthenticatedWorkOrdersIdIndexRoute
  '/work-orders/$id/worksheets/$worksheetId': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteWithChildren
  '/work-orders/$id/worksheets/$worksheetId/messages': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRoute
  '/work-orders/$id/worksheets/$worksheetId/': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRoute
  '/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRoute
  '/work-orders/$id/worksheets/$worksheetId/steps/$stepId': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/logout': typeof LogoutRoute
  '/request-access': typeof RequestAccessRoute
  '/login': typeof GuestLoginRoute
  '/assistances/$id': typeof AuthenticatedAssistancesIdRoute
  '/agenda': typeof AuthenticatedAgendaIndexRoute
  '/assistances': typeof AuthenticatedAssistancesIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/assets/$id': typeof AuthenticatedAssetsIdIndexRoute
  '/work-orders/$id': typeof AuthenticatedWorkOrdersIdIndexRoute
  '/work-orders/$id/worksheets/$worksheetId/messages': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRoute
  '/work-orders/$id/worksheets/$worksheetId': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRoute
  '/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRoute
  '/work-orders/$id/worksheets/$worksheetId/steps/$stepId': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_guest': typeof GuestRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/logout': typeof LogoutRoute
  '/request-access': typeof RequestAccessRoute
  '/_guest/login': typeof GuestLoginRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/assets/$id': typeof AuthenticatedAssetsIdRouteWithChildren
  '/_authenticated/assistances/$id': typeof AuthenticatedAssistancesIdRoute
  '/_authenticated/work-orders/$id': typeof AuthenticatedWorkOrdersIdRouteWithChildren
  '/_authenticated/agenda/': typeof AuthenticatedAgendaIndexRoute
  '/_authenticated/assistances/': typeof AuthenticatedAssistancesIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/assets/$id/': typeof AuthenticatedAssetsIdIndexRoute
  '/_authenticated/work-orders/$id/': typeof AuthenticatedWorkOrdersIdIndexRoute
  '/_authenticated/work-orders/$id/worksheets/$worksheetId': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteWithChildren
  '/_authenticated/work-orders/$id/worksheets/$worksheetId/messages': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRoute
  '/_authenticated/work-orders/$id/worksheets/$worksheetId/': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRoute
  '/_authenticated/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRoute
  '/_authenticated/work-orders/$id/worksheets/$worksheetId/steps/$stepId': typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/logout'
    | '/request-access'
    | '/login'
    | '/assets/$id'
    | '/assistances/$id'
    | '/work-orders/$id'
    | '/agenda/'
    | '/assistances/'
    | '/profile/'
    | '/assets/$id/'
    | '/work-orders/$id/'
    | '/work-orders/$id/worksheets/$worksheetId'
    | '/work-orders/$id/worksheets/$worksheetId/messages'
    | '/work-orders/$id/worksheets/$worksheetId/'
    | '/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId'
    | '/work-orders/$id/worksheets/$worksheetId/steps/$stepId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/logout'
    | '/request-access'
    | '/login'
    | '/assistances/$id'
    | '/agenda'
    | '/assistances'
    | '/profile'
    | '/assets/$id'
    | '/work-orders/$id'
    | '/work-orders/$id/worksheets/$worksheetId/messages'
    | '/work-orders/$id/worksheets/$worksheetId'
    | '/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId'
    | '/work-orders/$id/worksheets/$worksheetId/steps/$stepId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_guest'
    | '/forgot-password'
    | '/logout'
    | '/request-access'
    | '/_guest/login'
    | '/_authenticated/'
    | '/_authenticated/assets/$id'
    | '/_authenticated/assistances/$id'
    | '/_authenticated/work-orders/$id'
    | '/_authenticated/agenda/'
    | '/_authenticated/assistances/'
    | '/_authenticated/profile/'
    | '/_authenticated/assets/$id/'
    | '/_authenticated/work-orders/$id/'
    | '/_authenticated/work-orders/$id/worksheets/$worksheetId'
    | '/_authenticated/work-orders/$id/worksheets/$worksheetId/messages'
    | '/_authenticated/work-orders/$id/worksheets/$worksheetId/'
    | '/_authenticated/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId'
    | '/_authenticated/work-orders/$id/worksheets/$worksheetId/steps/$stepId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  GuestRoute: typeof GuestRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LogoutRoute: typeof LogoutRoute
  RequestAccessRoute: typeof RequestAccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof GuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-access': {
      id: '/request-access'
      path: '/request-access'
      fullPath: '/request-access'
      preLoaderRoute: typeof RequestAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_guest/login': {
      id: '/_guest/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof GuestLoginRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_authenticated/agenda/': {
      id: '/_authenticated/agenda/'
      path: '/agenda'
      fullPath: '/agenda/'
      preLoaderRoute: typeof AuthenticatedAgendaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets/$id': {
      id: '/_authenticated/assets/$id'
      path: '/assets/$id'
      fullPath: '/assets/$id'
      preLoaderRoute: typeof AuthenticatedAssetsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assistances/': {
      id: '/_authenticated/assistances/'
      path: '/assistances'
      fullPath: '/assistances/'
      preLoaderRoute: typeof AuthenticatedAssistancesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assistances/$id': {
      id: '/_authenticated/assistances/$id'
      path: '/assistances/$id'
      fullPath: '/assistances/$id'
      preLoaderRoute: typeof AuthenticatedAssistancesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/work-orders/$id': {
      id: '/_authenticated/work-orders/$id'
      path: '/work-orders/$id'
      fullPath: '/work-orders/$id'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets/$id/': {
      id: '/_authenticated/assets/$id/'
      path: '/'
      fullPath: '/assets/$id/'
      preLoaderRoute: typeof AuthenticatedAssetsIdIndexRouteImport
      parentRoute: typeof AuthenticatedAssetsIdRoute
    }
    '/_authenticated/work-orders/$id/': {
      id: '/_authenticated/work-orders/$id/'
      path: '/'
      fullPath: '/work-orders/$id/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersIdRoute
    }
    '/_authenticated/work-orders/$id/worksheets/$worksheetId': {
      id: '/_authenticated/work-orders/$id/worksheets/$worksheetId'
      path: '/worksheets/$worksheetId'
      fullPath: '/work-orders/$id/worksheets/$worksheetId'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersIdRoute
    }
    '/_authenticated/work-orders/$id/worksheets/$worksheetId/': {
      id: '/_authenticated/work-orders/$id/worksheets/$worksheetId/'
      path: '/'
      fullPath: '/work-orders/$id/worksheets/$worksheetId/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute
    }
    '/_authenticated/work-orders/$id/worksheets/$worksheetId/messages': {
      id: '/_authenticated/work-orders/$id/worksheets/$worksheetId/messages'
      path: '/messages'
      fullPath: '/work-orders/$id/worksheets/$worksheetId/messages'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute
    }
    '/_authenticated/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId': {
      id: '/_authenticated/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId'
      path: '/protocols/$additionalProtocolId'
      fullPath: '/work-orders/$id/worksheets/$worksheetId/protocols/$additionalProtocolId'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute
    }
    '/_authenticated/work-orders/$id/worksheets/$worksheetId/steps/$stepId': {
      id: '/_authenticated/work-orders/$id/worksheets/$worksheetId/steps/$stepId'
      path: '/steps/$stepId'
      fullPath: '/work-orders/$id/worksheets/$worksheetId/steps/$stepId'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute
    }
  }
}

interface AuthenticatedAssetsIdRouteChildren {
  AuthenticatedAssetsIdIndexRoute: typeof AuthenticatedAssetsIdIndexRoute
}

const AuthenticatedAssetsIdRouteChildren: AuthenticatedAssetsIdRouteChildren = {
  AuthenticatedAssetsIdIndexRoute: AuthenticatedAssetsIdIndexRoute,
}

const AuthenticatedAssetsIdRouteWithChildren =
  AuthenticatedAssetsIdRoute._addFileChildren(
    AuthenticatedAssetsIdRouteChildren,
  )

interface AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteChildren {
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRoute
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRoute
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRoute
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRoute
}

const AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteChildren: AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteChildren =
  {
    AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRoute:
      AuthenticatedWorkOrdersIdWorksheetsWorksheetIdMessagesRoute,
    AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRoute:
      AuthenticatedWorkOrdersIdWorksheetsWorksheetIdIndexRoute,
    AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRoute:
      AuthenticatedWorkOrdersIdWorksheetsWorksheetIdProtocolsAdditionalProtocolIdRoute,
    AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRoute:
      AuthenticatedWorkOrdersIdWorksheetsWorksheetIdStepsStepIdRoute,
  }

const AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteWithChildren =
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute._addFileChildren(
    AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteChildren,
  )

interface AuthenticatedWorkOrdersIdRouteChildren {
  AuthenticatedWorkOrdersIdIndexRoute: typeof AuthenticatedWorkOrdersIdIndexRoute
  AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute: typeof AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteWithChildren
}

const AuthenticatedWorkOrdersIdRouteChildren: AuthenticatedWorkOrdersIdRouteChildren =
  {
    AuthenticatedWorkOrdersIdIndexRoute: AuthenticatedWorkOrdersIdIndexRoute,
    AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRoute:
      AuthenticatedWorkOrdersIdWorksheetsWorksheetIdRouteWithChildren,
  }

const AuthenticatedWorkOrdersIdRouteWithChildren =
  AuthenticatedWorkOrdersIdRoute._addFileChildren(
    AuthenticatedWorkOrdersIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAssetsIdRoute: typeof AuthenticatedAssetsIdRouteWithChildren
  AuthenticatedAssistancesIdRoute: typeof AuthenticatedAssistancesIdRoute
  AuthenticatedWorkOrdersIdRoute: typeof AuthenticatedWorkOrdersIdRouteWithChildren
  AuthenticatedAgendaIndexRoute: typeof AuthenticatedAgendaIndexRoute
  AuthenticatedAssistancesIndexRoute: typeof AuthenticatedAssistancesIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAssetsIdRoute: AuthenticatedAssetsIdRouteWithChildren,
  AuthenticatedAssistancesIdRoute: AuthenticatedAssistancesIdRoute,
  AuthenticatedWorkOrdersIdRoute: AuthenticatedWorkOrdersIdRouteWithChildren,
  AuthenticatedAgendaIndexRoute: AuthenticatedAgendaIndexRoute,
  AuthenticatedAssistancesIndexRoute: AuthenticatedAssistancesIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface GuestRouteChildren {
  GuestLoginRoute: typeof GuestLoginRoute
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestLoginRoute: GuestLoginRoute,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  GuestRoute: GuestRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LogoutRoute: LogoutRoute,
  RequestAccessRoute: RequestAccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
